import { formatNumber } from './number';

export const formatCurrency = (
  amount: number | string,
  currencyCode: string,
  isNegative?: boolean,
): string => {
  let minusSign = '';
  let formattedAmount = amount;

  if (typeof formattedAmount === 'string') {
    formattedAmount = parseFloat(formattedAmount);
  }

  if (Math.sign(Number(amount)) === -1 || isNegative) {
    minusSign = '-';
  }

  formattedAmount = formatNumber(Math.abs(formattedAmount));

  if (currencyCode) {
    switch (currencyCode) {
      case 'BRL': {
        return `${minusSign}R$ ${formattedAmount}`;
      }
      case 'EUR': {
        return `${minusSign}€ ${formattedAmount}`;
      }
      default: {
        return `${minusSign}${formattedAmount}`;
      }
    }
  }

  return `${minusSign}${formattedAmount}`;
};
